import { render, staticRenderFns } from "./guessing-champion-bet.vue?vue&type=template&id=39322163&scoped=true&"
import script from "./guessing-champion-bet.vue?vue&type=script&lang=js&"
export * from "./guessing-champion-bet.vue?vue&type=script&lang=js&"
import style0 from "./guessing-champion-bet.vue?vue&type=style&index=0&id=39322163&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39322163",
  null
  
)

export default component.exports